import { Formik, Form } from 'formik'
import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import ButtonSubmitSave from '../../../components/button/ButtonSubmitSave'
import CheckBoxBasic from '../../../components/checkBox/CheckBoxBasic'
import InputTextBasic from '../../../components/textField/InputTextBasic'
import { ChangeMyPassApi } from '../../../http/Services/AuthApi'
import { toastToggleAction } from '../../../redux/action/toastAction'

export default function ModalChangeMyPass({
    show,
    setToggleModalPass   
}) {
    const [buttonDisabled, setButtonDisabled] = useState(false)
    const dispatch = useDispatch()
    const [showPass, setShowPass] = useState(false)
    const handleShowPass = () => {
        setShowPass(!showPass)
    }
    const handleClose = () => {
        setToggleModalPass(false)
    }

    return (
        <Modal show={show} onHide={handleClose} className='elevation-1' size='md'>
            <Modal.Header closeButton>
                <Modal.Title className='h6 fw-bold text-secondary'>Cambiar contraseña</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={{
                    password: ''
                }}

                onSubmit={(valores, { resetForm }) => {
                    setButtonDisabled(true)
                    // console.log(valores)
                    const createClient = async () => {
                        try {
                            let res = await ChangeMyPassApi(valores)
                            if (res.status === 200) {
                                // console.log(res.data)
                                // window.localStorage.setItem('token',res.data.token)
                                //window.sessionStorage.setItem('token',res.data.token)
                                dispatch(toastToggleAction({
                                    show: true,
                                    bg: 'success',
                                    title: 'Exito!',
                                    message: 'Contraseña renovada correctamente!',
                                    variant: 'bold'
                                }))
                                resetForm()
                                // recallAction()
                                handleClose()
                                setButtonDisabled(false)
                            }
                            else {
                                dispatch(toastToggleAction({
                                    show: true,
                                    bg: 'warning',
                                    title: 'Alerta!',
                                    message: 'Los datos podrian no haberse guardado!',
                                    variant: 'bold'
                                }))
                                setButtonDisabled(false)
                            }
                            // console.log(valores)
                        } catch (error) {
                            dispatch(toastToggleAction({
                                show: true,
                                bg: 'danger',
                                title: 'Error!',
                                message: 'Error al renovar contraseña cliente!',
                                variant: 'bold'
                            }))
                            setButtonDisabled(false)
                        }
                    }

                    createClient();
                }}
            >
                {({ values, handleChange }) => (
                    <React.Fragment>
                        <Form>
                            <Modal.Body>
                                <div className="row">
                                    <InputTextBasic
                                        id='password'
                                        placeholder='Nueva contraseña'
                                        name='password'
                                        icon={<i className='ion-locked'/>}
                                        type={showPass ? 'text' : 'password'}
                                        onChange={handleChange}
                                        value={values.password}
                                        disabled={buttonDisabled}
                                        lenght={4}
                                    />
                                    <div className="row">
                                        <CheckBoxBasic
                                            id='activo'
                                            name='activo'
                                            label='Mostrar contraseña'
                                            onChange={handleShowPass}
                                            value={showPass}
                                            disabled={buttonDisabled}
                                        />
                                    </div>

                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    Cancelar
                                </Button>
                                <ButtonSubmitSave
                                    text='Guardar'
                                    // color='#df5312'
                                    disabled={buttonDisabled}
                                />
                                {/* <Button variant="primary" onClick={handleClose}>
                                    Cancelar
                                </Button> */}
                            </Modal.Footer>
                        </Form>
                    </React.Fragment>
                )}
            </Formik>
        </Modal>
    )
}
